import { z } from 'zod';

export const COMMAND_PALETTE_INTERPRET_ENDPOINT = '/api/command-palette/interpret';
export const COMMAND_PALETTE_AI_MODEL = 'nvidia/nemotron-nano-9b-v2';
export const COMMAND_PALETTE_AI_PROVIDER = 'vercel-gateway-bedrock';
export const COMMAND_PALETTE_CONFIDENCE_THRESHOLD = 0.7;
export const COMMAND_PALETTE_MAX_COMMAND_CANDIDATES = 30;
export const COMMAND_PALETTE_MAX_ALTERNATIVES = 3;

export const commandPaletteAiCandidateSchema = z.object({
  id: z.string().min(1).max(160),
  label: z.string().min(1).max(200),
  group: z.string().max(120).optional(),
  keywords: z.array(z.string().max(120)).max(30).optional(),
  description: z.string().max(500).optional(),
  examples: z.array(z.string().max(160)).max(10).optional(),
  safeExecution: z.literal('navigation'),
});

export const commandPaletteInterpretRequestSchema = z.object({
  query: z.string().trim().min(1).max(500),
  currentPath: z.string().max(2048),
  currentSearchParams: z.record(z.string(), z.string()).default({}),
  candidates: z
    .array(commandPaletteAiCandidateSchema)
    .min(1)
    .max(COMMAND_PALETTE_MAX_COMMAND_CANDIDATES),
});

export const commandPaletteInterpretationSchema = z.object({
  type: z.enum(['execute', 'suggest', 'clarify', 'none']),
  commandId: z.string().nullable(),
  confidence: z.number().min(0).max(1),
  alternatives: z.array(z.string()).default([]),
  question: z.string().nullable().default(null),
});

export type CommandPaletteAiCandidate = z.infer<typeof commandPaletteAiCandidateSchema>;
export type CommandPaletteInterpretRequest = z.infer<typeof commandPaletteInterpretRequestSchema>;
export type CommandPaletteInterpretation = z.infer<typeof commandPaletteInterpretationSchema>;
